// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 759 ? "latex-linter-worker" : chunkId) + "." + {"225":"28c7b49c","759":"409e90b6"}[chunkId] + ".chunk.js";
};